import property from 'lodash/property';
import * as type from "./types";
import { Policy } from "../../model";
import axios from "axios";
import { _sendLog } from '../../utils/utility';

export const _storePolicyPayment = (policy : Policy ) => {
    _sendLog(['SME-React - Policy Service - _storePolicyPayment: ', JSON.stringify(policy, null, 3)], 'info');
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.POLICY_PAYMENT_STORE,
            data: policy
        })
    };
}

export const _fetchPolicyFailed = () => {
    return {
        type: type.POLICY_PAYMENT_FETCH_FAILED
    };
}

/**
 * Generates QR Code payment for PayNow option.
 * @param policy the policy details
 * @returns {function(): Promise<unknown>}
 */
export function _generateQrCode(policy: Policy) {
    console.log("_generateQrCode service");
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_GENERATE_QR_CODE, JSON.stringify(policy), {headers: {'Content-Type': 'application/json'}})
                .then(resp => {
                    if (resp?.data?.errorMessage) {
                        reject(resp);
                    } else {
                        resolve(resp.data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    _sendLog(['SME-React - Policy Payment Service - _generateQrCode: ', error])
                    reject(error);
                });
        })
    };
}

/**
 * Calls api to simulate QR Code payment for PayNow option.
 * @param tnxRef transaction reference
 * @returns {function(): Promise<unknown>}
 */
export function _simulateQrCodePayment(txnRef: string) {
    console.log("_simulateQrCodePayment service");
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_SIMULATE_QR_CODE_PAYMENT, {"txnRef": txnRef})
                .then(resp => {
                    dispatch({
                        type: type.POLICY_PAYMENT_STORE,
                        data: resp.data.policy
                    });
                    if (resp?.data?.errorMessage) {
                        reject(resp);
                    } else {
                        resolve(resp.data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    _sendLog(['SME-React - Policy Service - _simulateQrCodePayment: ', error])
                    reject(error);
                });
        })
    };
}

/*export const _simulateQrCodePayment = (txnRef) => {
    console.log("_simulateQrCodePayment service");
    return () => {
        return new Promise((resolve, reject) => {
            console.log("_simulateQrCodePayment REF: " + txnRef);
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            axios.post(server + process.env.REACT_APP_SIMULATE_QR_CODE_PAYMENT, {"txnRef": txnRef})
                .then( (resp) => {
                    if (resp?.data?.errorMessage) {
                        reject(resp);
                    } else {
                        resolve(resp.data);
                        // history.push()
                    }
                })
                .catch( error => {
                    reject(error);
                })
        })
    }
}
*/
/**
 * Calls api to check if payment already completed for QR Code payment for PayNow option.
 * @param policy
 * @returns {function(): Promise<unknown>}
 */
export function _checkQrCodePaymentComplete(policy: Policy) {
    console.log("_checkQrCodePaymentComplete begin...");
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_CHECK_QR_CODE_PAYMENT_COMPLETE, JSON.stringify(policy), {headers: {'Content-Type': 'application/json'}})
                .then(resp => {
                    dispatch({
                        type: type.POLICY_PAYMENT_STORE,
                        data: resp.data.policy
                    });
                    if (resp?.data?.errorMessage) {
                        reject(resp);
                    } else {
                        console.log("_checkQrCodePaymentComplete Payment Complete data... ");
                        console.log(resp.data);
                        resolve(resp.data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    _sendLog(['SME-React - Policy Service - _checkQrCodePaymentComplete: ', error])
                    reject(error);
                });
        })
    };
}
/*
export const _checkQrCodePaymentComplete = (policy) => {
    console.log("_checkQrCodePaymentComplete begin...");
   return () => {
        return new Promise((resolve, reject) => {
            console.log("_checkQrCodePaymentComplete  " + policy);
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            axios.post(server + process.env.REACT_APP_CHECK_QR_CODE_PAYMENT_COMPLETE, policy)
               .then( (resp) => {
                    if (resp?.data?.errorMessage) {
                        reject(resp);
                    } else {
                        console.log("_checkQrCodePaymentComplete Payment Complete data... ");
                        console.log(resp.data);
                        resolve(resp.data);
                    }
                })
                .catch( error => {
                    reject(error);
                })
        })
   }
}
*/
/**
 * Calls api to issue receipt QR Code payment for PayNow option.
 * @param policy
 * @returns {function(): Promise<unknown>}
 */
/*
export function _issueAndReceiptQrCode(policy: Policy) {
    console.log("_issueAndReceiptQrCode begin...");
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_ISSUE_QR_POLICY, JSON.stringify(policy), {headers: {'Content-Type': 'application/json'}})
                .then(resp => {
                    dispatch({
                        type: type.POLICY_PAYMENT_STORE,
                        data: resp.data.policy
                    });
                    if (resp?.data?.errorMessage) {
                        reject(resp);
                    } else {
                        console.log("_issueAndReceiptQrCode Policy Issued.. ");
                        console.log(resp.data);
                        resolve(resp.data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    _sendLog(['SME-React - Policy Service - _issueAndReceiptQrCode: ', error])
                    reject(error);
                });
        })
    };
}
*/
export const _getPolicyPayment = property('pp');
